import { Component, Inject, Input, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ConversationFlowStepResponse } from '../../../models/responses/conversation-flow-step-response';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { ConversationFlowArcResponse } from '../../../models/responses/conversational-flow-arc-response';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgIf } from '@angular/common';
import { ConversationStepService } from '../../../services/conversation-step.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-diagram-flow-children-selection-dialog',
  standalone: true,
  imports: [
    MatDividerModule,
    MatButtonModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule,
    NgIf,
    MatTableModule,
    MatInputModule,
    MatIconModule
  ],
  templateUrl: './diagram-flow-children-selection-dialog.component.html',
  styleUrl: './diagram-flow-children-selection-dialog.component.scss'
})
export class DiagramFlowChildrenSelectionDialogComponent {
  displayedColumns: string[] = ['Name', "Directive", "Action"];
  dataSource!: MatTableDataSource<any>;
  filteredChildren: ConversationFlowStepResponse[] = [];
  isLoading: boolean = false;
  shouldRenderConditionComponent: boolean = false;
  conditionFormControl: FormControl = new FormControl('', [Validators.required, Validators.minLength(3)]);
  currentChildToConnect: ConversationFlowStepResponse | undefined;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    public dialogRef: MatDialogRef<DiagramFlowChildrenSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { parent: ConversationFlowStepResponse, availableChildren: ConversationFlowStepResponse[], deleteNodeCallback: Function, aiAgentId: number },
    private conversationStepService: ConversationStepService,
    private snackBar: MatSnackBar
  ) {
    this.dataSource = new MatTableDataSource();
  }

  ngOnInit() {
    this.dataSource.data = this.data.availableChildren;
    this.dataSource.sort = this.sort;
  }

  onConnectClicked(child: ConversationFlowStepResponse) {
    this.shouldRenderConditionComponent = true;
    this.currentChildToConnect = child;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;

    this.dataSource.data = this.data.availableChildren.filter(step => step.name.toLowerCase().includes(filterValue.toLowerCase()));
  }

  onAddArc() {
    if (this.conditionFormControl.valid) {
      const arcToCreate: ConversationFlowArcResponse = {
        currentStepId: this.data.parent.id,
        nextStepId: this.currentChildToConnect!.id,
        condition: this.conditionFormControl.value
      };

      this.isLoading = true;

      this.conversationStepService.createArc(arcToCreate, this.data.aiAgentId).subscribe({
        next: (steps) => {
          this.isLoading = false;
          this.snackBar.open('Step connected successfully', 'Close', { duration: 5000 });
          this.dialogRef.close(steps);
        },
        error: () => {
          this.isLoading = false;
          alert('Server error contact support');
        }
      });
    }
  }

  onBackCancelClicked() {
    if (this.shouldRenderConditionComponent) {
      this.shouldRenderConditionComponent = false;
      this.currentChildToConnect = undefined;
      this.conditionFormControl.reset();
    } else {
      this.dialogRef.close();
    }
  }
}
